import React from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

const ButtonComponent = ({ children, loadingText, loading, className, disabled, variant, type, ...rest }: any) => {
  return (
    <Button disabled={disabled || loading} variant={variant} className={className} type={type} {...rest}>
      {loading ? loadingText || children : children}
      {loading && <CircularProgress color="inherit" size={15} />}
    </Button>
  );
};

ButtonComponent.defaultProps = {
  variant: "contained",
  children: "Button",
  loadingText: null,
  loading: false,
  disabled: false,
  className: "",
};

export default ButtonComponent;
